import styled from "styled-components";
import { PersonalDataRulesContainer, PersonalDataRulesLabel, RegistrationContainer, 
    RegistrationHeading, RegistrationSubHeading, } from 'pages/registration/registration.styles';

export const SubscriptionDetailsContainer = styled(RegistrationContainer)``;

export const SubscriptionDetailsHeading = styled(RegistrationHeading)``;

export const SubscriptionDetailsSubHeading = styled(RegistrationSubHeading)``;

export const SubscriptionDetailsProInnerContainer = styled.div`
    margin: 41px 37px 30px;
`;

export const SubscriptionDetailsProInnerHeading = styled.div`
    font-size: 20px;
    color: #142C1F;
    margin-bottom: 30px;
`;

export const SubscriptionDetailsProInnerDetailsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const SubscriptionDetailsProInnerDetailsFlexColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: ${props => props.width ? props.width : '100%' };
`;

export const SubscriptionDetailsProInnerIconContainer = styled.div`
    width: 90px;
    height: 90px;
    background-color: #142C1F;
    border-radius: 10px;
    color: white;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const SubscriptionDetailsProInnerDetailsHeading = styled.div`
    font-size: 18px;
    color: #142C1F;
    margin-top: 10px;
    margin-bottom: 5px;
`;

export const SubscriptionDetailsProInnerDetailsSubHeading = styled.div`
    font-size: 14px;
    color: #A5B5AF;
    font-family: RubikRegular;
    margin-bottom: 10px;
`;

export const SubscriptionDetailsProInnerDetailsDescription = styled.div`
    font-size: 14px;
    color: #44554C;
    font-family: RubikRegular;
    margin-bottom: 25px;
`;

export const SubscriptionDetailsProInnerDetailsOneTimePayment = styled.div`
    display: flex;
    flex-direction: row;
    font-family: RubikRegular;
    color: #707070;
`;

export const SubscriptionDetailsProInnerDetailsCostContainer = styled.div`
    background-color: #F5F5F5;
    color: #1C9D87;
    font-size: 18px;
    width: 106px;
    height: 43px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    margin-bottom: 7px;
`;

export const SubscriptionDetailsRulesContainer = styled(PersonalDataRulesContainer)``;

export const SubscriptionDetailsRulesLabel = styled(PersonalDataRulesLabel)`
    width: 600px;
`;